(_ => {
  const initPaywall = () => {
    const elRoot = document.getElementById('paywall')
    if (!elRoot) return;

    const El = {
      close: elRoot.querySelector('.pw-close'),
      back: elRoot.querySelector('.pw-back'),
      container: elRoot.querySelector('.pw-content'),
      main: elRoot.querySelector('.pw-main'),
      signinSIW: elRoot.querySelector('.pw-siw-google.signin'),
      signupSIW: elRoot.querySelector('.pw-siw-google.signup'),
      signinForm: elRoot.querySelector('.pw-form.signin'),
      signinFormEmail: elRoot.querySelector('#pw-signin-email'),
      signinFormPassword: elRoot.querySelector('#pw-signin-password'),
      signupForm: elRoot.querySelector('.pw-form.signup'),
      signupFormEmail: elRoot.querySelector('#pw-signup-email'),
      signupFormFName: elRoot.querySelector('#pw-signup-first-name'),
      signupFormLName: elRoot.querySelector('#pw-signup-last-name'),
      signupFormPassword: elRoot.querySelector('#pw-signup-password'),
      next: elRoot.querySelector('.pw-next'),
      submit: elRoot.querySelector('.pw-submit'),
      submitErrors: elRoot.querySelector('.pw-form.signup .pw-submit-errors'),
      signinSubmitErrors: elRoot.querySelector('.pw-form.signin .pw-submit-errors'),
      stepHeading: elRoot.querySelector('.pw-step-heading'),
      signinRecpatcha: elRoot.querySelector('.pw-signin-recaptcha'),
      signupRecpatcha: elRoot.querySelector('.pw-signup-recaptcha'),
      togglePassword: elRoot.querySelector('.pw-toggle-password label'),
      signupPassword: elRoot.querySelector('#pw-signup-password'),
      passwordErrors: elRoot.querySelector('.pw-password-errors'),
    }

    const Els = {
      switch: elRoot.querySelectorAll('.pw-switch'),
      inputs: elRoot.querySelectorAll('.pw-form-group input'),
    }

    const Fn = {
      open: _ => {
        if (document.body.classList.contains('open-pw')) return;
        if (window._user.isLogined()) return;

        document.body.classList.add('open-pw');
        Fn.setCurStep('start');
        Fn.initValidatePassword(El.signupPassword);

        if (typeof window.__initsiw === 'function') {
          window.__initsiw();
          clearTimeout(window.__initsiwTimer);
        }
        window._user.renderSIWGoogleButton(El.signupSIW, {
          width: El.signupSIW.offsetWidth > 0 ? El.signupSIW.offsetWidth : 288,
          cb: _ => {
            window.siw_google_via = 'sign-up-wall';
          }
        })

      },
      close: _ => {
        document.body.classList.remove('open-pw');
      },
      showWelcome: _ => {
        El.container.classList.add('welcome');
        setTimeout(_ => {
          El.container.querySelector('.pw-welcome img').classList.add('loaded');
        }, 10)
      },
      activePaywall: (timeout = 3000) => {
        elRoot.classList.add('pw-loaded');
        setTimeout(Fn.open, timeout);
      },
      setCurStep: (step, el=El.signupForm) => {
        el.dataset.curStep = step;
        switch (step) {
          case 'start':
            El.stepHeading.textContent = el.classList.contains('signup') ? 'Enter your Email' : 'Sign in to your Money Account';
            El.back.style.visibility = 'hidden';
            break;
          case 'name':
            El.stepHeading.textContent = 'Enter your Name';
            El.back.style.visibility = 'visible';
            break;
          case 'password':
            El.stepHeading.textContent = 'Enter a Password';
            El.back.style.visibility = 'visible';
            break;
        }
      },
      getCurStep: _ => {
        return El.signupForm.dataset.curStep;
      },
      setFocusIfEmpty: (el) => {
        window.setTimeout(_ => {
          if (!el.value) el.focus();
        }, 350)
      },
      clearForm: (elForm) => {
        [].slice.call(elForm.elements).map(el => {
          if (el.tagName === 'INPUT') {
            if (~['text', 'email', 'password', 'number'].indexOf(el.type)) [
              el.value = ''
            ]
          }
        })
      },
      setFormAjaxLoading: (elForm, isLoading) => {
        const els = [].slice.call(elForm.elements)
        if (isLoading) {
          elForm.classList.add('ajax-loading')
          els.map(el => el.disabled = true)
        } else {
          elForm.classList.remove('ajax-loading')
          els.map(el => el.disabled = false)
        }
      },
      setInputError: (elInput, msg) => {
        if (!elInput) return
        const elCon = elInput.parentNode
        let elErrMsg = elCon.querySelector('.err-msg')
        if (!elErrMsg) {
          elErrMsg = document.createElement('div')
          elErrMsg.classList.add('err-msg')
          elCon.appendChild(elErrMsg);
        }
        if (typeof msg === 'undefined') {
          elCon.classList.remove('has-error')
        } else {
          elErrMsg.innerText = msg
          elCon.classList.add('has-error')
        }
      },
      isEmail: (str) => {
        return /^[\w.%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(str || '') ? str.toLowerCase() : null;
      },
      validateEmail: (elInput) => {
        if (elInput) {
          if (!elInput.dataset.vEmailInited) {
            elInput.addEventListener('keyup', function() {
              const lastVal = elInput.dataset.lastVal || undefined
              if (lastVal !== elInput.value) {
                elInput.dataset.lastVal = val
                Fn.validateEmail(elInput)
              }
            })
            elInput.dataset.vEmailInited = 1;
          }
          const val = elInput.value
          if (val) {
            if (Fn.isEmail(val)) {
              Fn.setInputError(elInput)
              return true
            } else {
              Fn.setInputError(elInput, 'Enter a valid email address')
            }
          } else {
            Fn.setInputError(elInput, 'Email is required.')
          }
        }
      },
      validateRequired: (elInput) => {
        if (elInput) {
          if (!elInput.dataset.vEmailInited) {
            elInput.addEventListener('keyup', function() {
              var lastVal = elInput.dataset.lastVal || undefined
              if (lastVal !== elInput.value) {
                elInput.dataset.lastVal = val
                Fn.validateRequired(elInput)
              }
            })
            elInput.dataset.vEmailInited = 1;
          }
          const val = elInput.value
          const ph = elInput.placeholder
          if (val) {
            Fn.setInputError(elInput)
            return true
          } else {
            Fn.setInputError(elInput, 'Enter ' + ph)
          }
        }
      },
      setPasswordErrors: (flags) => {
        var elCon = El.passwordErrors.parentNode
        if (flags instanceof Object) {
          El.passwordErrors.querySelector('.uppercase').dataset.status = flags.uppercase ? 'right' : 'wrong'
          El.passwordErrors.querySelector('.number').dataset.status = flags.number ? 'right' : 'wrong'
          El.passwordErrors.querySelector('.eight-chars').dataset.status = flags.eightChars ? 'right' : 'wrong'
          elCon.classList.add('has-error')
        } else {
          if (flags === true) {
            [].slice.call(El.passwordErrors.querySelectorAll('li')).map(function(el) { el.dataset.status = "right" })
            elCon.classList.remove('has-error')
          } else if (flags === false) {
            [].slice.call(El.passwordErrors.querySelectorAll('li')).map(function(el) { el.dataset.status = "wrong" })
            elCon.classList.add('has-error')
          } else {
            [].slice.call(El.passwordErrors.querySelectorAll('li')).map(function(el) { el.dataset.status = "" })
            elCon.classList.remove('has-error')
          }
        }
      },
      initValidatePassword: (elInput) => {
        if (!elInput.dataset.vEmailInited) {
          elInput.addEventListener('keyup', function() {
            var lastVal = elInput.dataset.lastVal || undefined
            if (lastVal !== elInput.value) {
              elInput.dataset.lastVal = elInput.value
              Fn.validatePassword(elInput)
            }
          })
          elInput.dataset.vEmailInited = 1;
        }
      },
      validatePassword: (elInput) => {
        if (elInput) {
          var val = elInput.value
          if (val) {
            var testUppercase = /[A-Z]+/.test(val)
            var testNumber = /[0-9]+/.test(val)
            var testEightChars = val.length >= 8
            var flags = {}
            if (testUppercase) {
              flags.uppercase = 1
            }
            if (testNumber) {
              flags.number = 1
            }
            if (testEightChars) {
              flags.eightChars = 1
            }
            if (testUppercase && testNumber && testEightChars) {
              Fn.setPasswordErrors(true)
              return true
            } else {
              Fn.setPasswordErrors(flags)
            }
          } else {
            Fn.setPasswordErrors(false)
          }
        }
      },
      checkLabelPlaceholder: (elInput) => {
        if (elInput.value) {
          elInput.classList.add('present')
        } else {
          elInput.classList.remove('present')
        }
      }
    }

    El.close.addEventListener('click', Fn.close);
    El.back.addEventListener('click', _ => {
      const curStep = Fn.getCurStep();
      switch (curStep) {
        case 'name':
          Fn.setCurStep('start');
          break;
        case 'password':
          Fn.setCurStep('name');
          break;
      }
    })
    El.togglePassword.addEventListener('click', _ => {
      El.signupPassword.type = El.signupPassword.type === 'password' ? 'text' : 'password';
    })
    El.signupForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopPropagation();
      const curStep = Fn.getCurStep();
      switch (curStep) {
        case 'start':
          if (Fn.validateEmail(El.signupFormEmail)) {
            Fn.setFormAjaxLoading(El.signupForm, true)
            window._user.api.checkEmailExists(El.signupFormEmail.value, function (err, result) {
              if (!err) {
                if (result.data && result.data.state === "not_exists") {
                  Fn.setCurStep('name')
                  Fn.setFocusIfEmpty(El.signupFormFName)
                } else {
                  Fn.setInputError(El.signupFormEmail, 'This email is already registered. Try another or Sign In.')
                }
              } else {
                El.submitErrors.innerText = err.message
                El.submitErrors.classList.add('has-error')
              }
              Fn.setFormAjaxLoading(El.signupForm)
            })
          }
          break;
        case 'name':
          const vFName = Fn.validateRequired(El.signupFormFName)
          const vLName = Fn.validateRequired(El.signupFormLName)
          if (vFName && vLName) {
            Fn.setCurStep('password');
            Fn.setFocusIfEmpty(El.signupFormPassword)
            El.submitErrors.classList.remove('has-error');
            if (El.signupRecpatcha.dataset.widgetId) {
              reCaptchaClient.reset(El.signupRecpatcha)
            } else {
              reCaptchaClient.renderCheckbox(El.signupRecpatcha)
            }
          }
          break;
        case 'password':
         if (Fn.validatePassword(El.signupFormPassword)) {
           let sendJson = {
              email: El.signupFormEmail.value,
              password: El.signupFormPassword.value,
              first_name: El.signupFormFName.value,
              last_name: El.signupFormLName.value,
              signup_source: 'sign-up-wall',
           }
           Fn.setFormAjaxLoading(El.signupForm, true)
           El.submitErrors.classList.remove('has-error');
           reCaptchaClient.verifyV2Only(El.signupRecpatcha, 'subscribe_wall', function(err, appendToken) {
             if (!err) {
               sendJson = appendToken(sendJson)
               sendJson = window._user.api.withReferer(sendJson)
               window._user.api.signUpActive(sendJson, function(err, data) {
                 if (err) {
                   El.submitErrors.innerText = err.message || 'Error occurred.'
                   El.submitErrors.classList.add('has-error');
                 } else {
                   window._user.signUpActiveDataTracking(true)
                   Fn.clearForm(El.signupForm)
                   Fn.showWelcome();
                 }
                 Fn.setFormAjaxLoading(El.signupForm)
               });
             } else {
               El.submitErrors.innerText = err.message
               El.submitErrors.classList.add('has-error')
               Fn.setFormAjaxLoading(El.signupForm)
             }
           });
         }
          break;
      }
    })
    El.signinForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopPropagation();
      const vEmail = Fn.validateEmail(El.signinFormEmail)
      const vPassword = Fn.validateRequired(El.signinFormPassword)
      if (vEmail && vPassword) {
        const email = El.signinFormEmail.value
        const password = El.signinFormPassword.value
        Fn.setFormAjaxLoading(El.signinForm, true)
        El.signinSubmitErrors.classList.remove('has-error');
        let sendJson = {
          email: email,
          password: password,
        }
        window._user.api.signIn(sendJson, function(err, data){
          if (err) {
            if ('reCaptchaV3Failed' === err.message) {
              reCaptchaClient.renderCheckbox(El.signinRecpatcha);
            } else {
              El.signinSubmitErrors.innerText = err.message || 'Error occurred.'
              El.signinSubmitErrors.classList.add('has-error');
            }
          } else {
            window._user.setLogined(data.data)
            window._user.signInDataTracking('email', false, 'sign-up-wall');
            Fn.close();
            window._toast.show('Log in successful. Welcome back!')
            reCaptchaClient.clear(El.signinRecpatcha)
            Fn.clearForm(El.signinForm)
          }
          Fn.setFormAjaxLoading(El.signinForm)
        })
      }
    })

    Els.switch.forEach(el => {
      el.addEventListener('click', _ => {
        const formTarget = el.dataset.formTarget;
        El.main.dataset.curForm = formTarget;
        if (formTarget === 'signup') {
          Fn.setCurStep('start');
        } else {
          Fn.setCurStep('start', El.signinForm)
          window._user.renderSIWGoogleButton(El.signinSIW, {
            width: El.signinSIW.offsetWidth > 0 ? El.signinSIW.offsetWidth : 288,
            cb: _ => {
              window.siw_google_via = 'sign-up-wall';
            }
          })
        }
      })
    });
    Els.inputs.forEach(el => {
      el.addEventListener('change', _ => {
        Fn.checkLabelPlaceholder(el)
      })
      Fn.checkLabelPlaceholder(el)
    })


    Fn.activePaywall(2000);

    window.__pwfn = Fn
  }

  if (document.body.dataset.mujs === 'inited') {
    initPaywall();
  } else {
    document.body.addEventListener('mujs:inited', initPaywall);
  }
})();
